export function commaFormat(value) {
  if (value === null || value === undefined) {
    return '0';
  }
  return value.toString().replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
    return pre + groupOf3Digital.replace(/\d{3}/g, ',$&');
  });
}
